import { combineReducers } from 'redux';

import calendarsUiReducer from './calendarsUiReducer';
import calendarsDataReducer from './calendarsDataReducer';

export default combineReducers({
  ui: calendarsUiReducer,
  data: calendarsDataReducer,
});
